import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Subject } from 'rxjs';
import { Page } from 'src/app/models/data/page.model';
import { User } from 'src/app/models/data/user.model';

@Injectable({
  providedIn: 'root',
})
export class ReviewSurveyService {
  localUser!: User;
  p!: Page[];
  private pages = new Subject<Page[]>();
  constructor(private http: HttpClient) { }

  getSurveyReview() {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http
      .get(`${environment.apiUrl}/Page/Invalid`, { headers: headers })
      .subscribe((res) => {
        this.p = <Page[]>res;
        this.pages.next(this.p);
      });
  }

  checkCompleted() {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http.get<{ completed: any }>(
      `${environment.apiUrl}/Completed`,
      { headers: headers },
    );
  }

  completeSurvey() {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
    });
    return this.http.put(
      `${environment.apiUrl}/Complete`,
      null,
      { headers: headers },
    );
  }

  getUserData() {
    const user: {
      username: string;
      token: string;
      status: number;
    } = JSON.parse(localStorage.getItem('user') as string);
    this.localUser = user;
  }

  getPageStatusObs() {
    return this.pages.asObservable();
  }
}
